import React from 'react'
import styled, { css } from 'styled-components'
import { SelectInput, Paragraph, Popover } from 'buoy-core'
import { colors, fontSize } from 'buoy-theme'
import { responsive } from "../../common/styledHelpers"
// 4851-todo: update responsive helper

const Arrow = styled.div`
  width: 12px;
  height: 10px;
  display: inline-block;
  position: relative;
  border-top: solid 10px ${colors.neutralLight};
  border-left: solid 6px transparent;
  border-right: solid 6px transparent;

  transition: all 0.5s ease;
  ${({ expanded }) =>
    expanded ? "" :
    css`
      transform: rotate(-90deg);
    `};
  `

const ArrowWrapper = styled.div`
  right: 20px;
  width: 0;
  padding: 0;
  position: relative;
  background: none;
  border: none;
`

const ToolTip = styled(Popover).attrs({
  hoverable: true,
})`
  height: 16px;
  width: 16px;
  max-width: 16px;
  max-height: 16px;
  margin: auto 4px;
  text-align: left;
  ${responsive(
    "margin-bottom",
    "0",
    "6px"
  )};
`

const CategoryContainer = styled.section`
  ${responsive(
    "padding",
    "24px 0",
    "20px 0")};
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  ${props => props.isEditing ? '' : css`
    align-items: flex-start;
  `};

  ${props => props.last ?
    responsive(
      "padding-bottom",
      "24px",
      "8px"
    ) : css`
    border-bottom: 1px solid ${colors.neutralLighter};
  `};

  &:first-child {
    padding-top: 0;
  }
`

const SectionWrapper = styled.div`
  width: 100%;
  align-items: center;
  ${responsive(
    "margin-bottom",
    "8px",
    "12px"
  )};
  ${props => props.inline ? css`
    display: inline-flex;

    ${props => props.isEditing ? css`
      flex-direction: row;
    ` : css`
      ${responsive("flex-direction", "row", "column")};
    `};
  ` : css`
    display: flex;
    flex-direction: column;
  `};
`

const OptionWrapper = styled.div`
  ${props => props.inline ? css`
    align-self: flex-end;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    
    ${props => props.subList ? css`
      ${responsive(
        "width",
        "50%",
        "auto"
      )};
      ${responsive(
        "margin",
        "0 0 0 auto",
        "0 -6px 0 auto")};
    ` : css`
      ${responsive(
        "width",
        "50%",
        "100%")};
      ${responsive(
        "margin",
        "0 0 0 auto",
        "0 auto 0 -12px")};
    `};
  ` : css`
    align-self: flex-start;
    ${props => props.subList ?
      responsive(
        "padding-left",
        "66px",
        "8px") :
      responsive(
        "padding-left",
        "18px",
        "12px")
    };
    display: flex;
    flex-direction: column;
    margin-top: 4px;
    ${responsive(
      "width",
      "50%",
      "100%")};
  `};
`

const HeadingContainer = styled.div`
  ${props => props.isEditing ? css`
    width: 100%;
  ` : css`
    ${responsive("width", "50%", "100%")};
  `};
  display: inline-flex;
  align-items: center;
  ${responsive(
    "padding",
    "0 0 0 36px",
    "0"
  )};
`

const Heading = styled(Paragraph)`
  display: inline-flex;
  line-height: 1.25;

  ${props => props.isEditing ? '' : css`
    margin-bottom: 4px;
  `};

  ${props => props.label ? css`
    ${responsive(
      "margin",
      "0 31px",
      "0 12px 8px")};

    &:first-child {
      ${responsive(
        "margin-left",
        "7px",
        "0")};
    }

    &:last-child {
      margin-right: 0;
    }
  ` : css``};
`

const SubHeading = styled(Heading)`
  ${fontSize("bodyMain")};
  margin-bottom: 0;
  margin-left: 20px;
  margin-right: 6px;
`

const SubHeadingButton = styled(SubHeading.withComponent("button"))`
  border: none;
  background: none;
  padding: 0;
  display: flex;
  text-align: left;
`

const ResponseText = styled(Heading)`
  ${responsive("width", "50%", "100%")};
  ${responsive("margin", " 0 0 0 auto", "0")};
  ${props => props.subSection ? css`
    ${responsive("padding-left", "0", "20px")};
  ` : ''};
`

const Option = styled(SelectInput)`
  ${props => props.inline ? css`
    display: inline-flex;
    ${responsive(
      "margin",
      "0 6px",
      "0")};

    &:first-child {
      margin-left: 0;
      ${responsive(
        "margin-left",
        "-28px",
        "0"
      )};
    }

    &:last-child {
      margin-right: 0;
    }

  ` : css`
    display: flex;
    ${responsive(
      "min-width",
      "224px",
      "unset")};
    width: 100%;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  `};

  ${props => props.inputOnly ?
    css`
      padding: 6px;
      border-radius: 50%;
      ${responsive(
        "margin",
        "0 29px",
        "0 16px"
      )};
    
      &:first-child {
        ${responsive(
          "margin-left",
          "-40px",
          "0")};
      }
      
      &:last-child {
        margin-right: 0;
      }

      div {
        margin: 0;
      }
    ` :
  ''};
`

Option.defaultProps = {
  inline: false,
  inputOnly: false,
  subList: false,
}

const Options = ({
  options,
  selected,
  question,
  questionIndex,
  inputType,
  inline,
  inputOnly,
  subList,
  optionParent,
  extension,
  onClick,
}) => (
  <OptionWrapper inline={inline} inputOnly={inputOnly} subList={subList}>
    {options && Object.keys(options)
      .sort((a, b) => options[a].order - options[b].order)
      .map(k => (
        <Option
          key={options[k].token}
          label={inputOnly ? "" : options[k].text}
          value={options[k].token}
          name={question.text}
          type={inputType}
          labelledBy=""
          inline={inline}
          inputOnly={inputOnly}
          selected={
            selected === k ||
            (!!selected && selected.length > 0 && selected.includes(k))
          }
          onClick={onClick(options[k].token, questionIndex, optionParent, extension)}
        />
      ))}
  </OptionWrapper>
)

const ExpandableSubHeading = ({ expandable, expanded, onMouseDown, question, onClick }) => (
  <React.Fragment>
    <SubHeadingButton canExpand={expandable} onClick={onClick} onMouseDown={onMouseDown}>
      {expandable && <ArrowWrapper>
        <Arrow expanded={expanded} />
      </ArrowWrapper>}
      {question.text}
    </SubHeadingButton>
    {question.tooltip && <ToolTip message={question.tooltip} />}
  </React.Fragment>
)

const Question = ({
  last,
  question,
  onAnswer,
  expandable,
  expanded,
  questionIndex,
  getExtensions,
  toggleExpanded,
  arrowMouseDown,
  getExtensionParent,
}) => (
  <SectionWrapper last={last} isEditing={true}>
    <HeadingContainer isEditing={true}>
      {question.text && <ExpandableSubHeading
        expanded={expanded}
        question={question}
        expandable={expandable}
        onClick={toggleExpanded}
        onMouseDown={arrowMouseDown}
      />}
      {question.options && <Options
        question={question}
        questionIndex={questionIndex}
        onClick={onAnswer}
        name={question.text}
        inline={true}
        inputOnly={true}
        inputType='radio'
        label=''
        subList={true}
        options={question.options}
        selected={question.answer}
      />}
    </HeadingContainer>
    {expandable && expanded &&
      getExtensions().map(
        (extension, extensionIndex) => (
          <Options
            key={extension.token}
            question={question}
            questionIndex={questionIndex}
            optionParent={getExtensionParent(extension.token)}
            extension={extensionIndex}
            name={question.text}
            selected={extension.answer}
            options={extension.options}
            inputType={extension.display_type}
            onClick={onAnswer}
            inline={false}
            subList={true}
          />
        )
      )
    }
  </SectionWrapper>
)

class SubListWrapper extends React.Component {
  state = {
    expanded: false,
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.expand !== prevProps.expand && this.props.expand !== null) {
      this.setState({ expanded: !!this.props.expand })
    }
  }

  arrowMouseDown = e => {
    e.preventDefault()
  }

  toggleExpanded = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  getExtensions = () => {
    let { question } = this.props
    let token = this.hasExtensions()
    return question.options[token].extensions
  }

  hasExtensions = () => {
    let { question } = this.props
    return Object.keys(question.options).find(k => question.options[k].extensions.length > 0)
  }

  onAnswer = (token, question, option, extension) => () => {
    this.props.setEdited(true)
    let q = this.props.question
    this.props.setAnswer(
      this.props.category,
      token,
      question,
      option,
      extension
    )
  
    let expand = q.options[q.answer] && q.options[q.answer].extensions.length > 0 ? true : false
    this.setState({ expanded: expand })
  }

  getExtensionParent = extensionToken => {
    let { question } = this.props
    return Object.keys(question.options).find(k => question.options[k].extensions.find(e => e.token === extensionToken))
  }

  render() {
    let expandable = this.hasExtensions()
    return (
      <Question
        {...this.state}
        {...this.props}
        expandable={expandable}
        onAnswer={this.onAnswer}
        toggleExpanded={this.toggleExpanded}
        arrowMouseDown={this.arrowMouseDown}
        getExtensions={this.getExtensions}
        getExtensionParent={this.getExtensionParent}
      />
    )
  }
}

SubListWrapper.defaultProps = {
  last: false,
  selectAll: null,
  toggleOptions: [],
}

export { SubListWrapper as default,
  CategoryContainer,
  Heading,
  ResponseText,
  Option,
  ToolTip,
  SectionWrapper,
  OptionWrapper,
}


// WEBPACK FOOTER //
// ./assets/account/components/CardSubSection.js